var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgServer = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12 13.363c2.696 0 5.281.911 7.187 2.53 1.424 1.21 2.382 2.743 2.775 4.396.221.927-.556 1.71-1.492 1.711H3.53c-.935 0-1.713-.784-1.492-1.71.393-1.654 1.351-3.186 2.775-4.396 1.906-1.62 4.492-2.53 7.188-2.53Zm2.774 3.137a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-2ZM12.001 3c2.338 0 4.234 1.934 4.234 4.318 0 2.385-1.896 4.319-4.234 4.319-2.34 0-4.236-1.934-4.236-4.319S9.662 3 12.001 3Z"
})));
SvgServer.viewBox = null;
const ForwardRef = /*#__PURE__*/forwardRef(SvgServer);
export default ForwardRef;